import React, { useRef } from "react";
import classes from "./BranchesList.module.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import useDeviceWidth from "../../../components/device-width/UseDeviceWidth";
import BranchCard from "./branches-card/BranchesCard";
import { repeatObjects } from "../../home-page/Branch-Carousel/BranchCarousel";
import { useSelector } from "react-redux";

const BranchesList = ({ data, title }) => {
  const swiperRef = useRef(null);
  const width = useDeviceWidth();
  const { homeApis } = useSelector((state) => state.widget); // Access widget data

  return (
    <div className={`${classes.outer}`}>
      <div className={classes.inner}>
        <div className={classes.innerContent}>
          {/* <div className={classes.title} data-aos="fade-down" data-aos-delay="200">
            <div>
              <h2 className="primary-300">{title}</h2>
            </div>

            <div className={`${classes.underLine} bg-primary-500`}></div>
          </div> */}
          <div className={classes.sliderOuter}>
            <div className={classes.arrowDiv}>
              <img
                src="/img/title-symbol.svg"
                className={classes.titleSymbol}
                alt="symbol"
              ></img>
              <div className={classes.arrows}>
                <img
                  className={classes.leftArrow}
                  src="/img/doctor-left.svg"
                  alt="Prev"
                  onClick={() => swiperRef.current?.slidePrev()} // Trigger previous slide
                />
                <img
                  src="/img/doctor-right.svg"
                  className={classes.rightArrow}
                  alt="Next"
                  onClick={() => swiperRef.current?.slideNext()} // Trigger next slide
                />
              </div>
            </div>
            <div className="outer-outer">
              <div
                onMouseEnter={() => swiperRef.current?.autoplay.stop()}
                onMouseLeave={() => swiperRef.current?.autoplay.start()}
              >
                {/* Custom Navigation Arrows */}

                {/* Swiper */}
                <Swiper
                  //   modules={[Navigation, Pagination]}
                  slidesPerView={
                    width > 1800
                      ? 3.1
                      : width > 1500
                      ? 2.7
                      : width > 1350
                      ? 2.3
                      : width > 1170
                      ? 2.3
                      : width > 930
                      ? 1.6
                      : width > 768
                      ? 1.4
                      : width > 600
                      ? 2.7
                      : width > 480
                      ? 2
                      : 1.3
                  } // Show 3 images at a time
                  spaceBetween={20} // Add space between slides
                  onSwiper={(swiper) => (swiperRef.current = swiper)} // Attach the Swiper instance to the ref
                  pagination={{ clickable: true }} // Enable clickable dots
                  loop={true} // Enable infinite looping
                  draggable={true} // Enable drag/swipe functionality
                  modules={[Autoplay]}
                  autoplay={{
                    delay: 5000, // 3 seconds
                    disableOnInteraction: false, // Autoplay continues even after interaction
                  }}
                >
                  {repeatObjects(data)?.map((slide) => (
                    <SwiperSlide key={slide.id}>
                      <BranchCard data={slide} />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BranchesList;
